import { fetchConToken } from "../helpers/fetch";

const ContratacionesConveniosService = {

  traerConveniosPorPracticas: (idEfectorFacturacion, codigoPractica) => {
    return fetchConToken(
      `Valorizaciones/ObtenerTodas/${idEfectorFacturacion}/${codigoPractica}`
    );
  },

  traerEquivalenciasNomencladores: (idEfectorFacturacion) => {
    return fetchConToken(
      `EquivalenciasNomencladores/${idEfectorFacturacion}`
    );
  },
  crearEquivalencia: (data) => {
    return fetchConToken(
      `EquivalenciasNomencladores`,
      data,
      "POST"
    );
  },
  editarEquivalencia: (idEquivalenciaNomencladores, data) => {
    return fetchConToken(
      `EquivalenciasNomencladores/${idEquivalenciaNomencladores}`,
      data,
      "PUT"
    );
  },
  eliminarEquivalencia: (idEquivalenciaNomencladores) => {
    return fetchConToken(
      `EquivalenciasNomencladores/${idEquivalenciaNomencladores}`,
      {},
      "DELETE"
    );
  },
  eliminarTodasEquivalencias: (idEfectorFacturacion) => {
    return fetchConToken(
      `EquivalenciasNomencladores/eliminarTodos/${idEfectorFacturacion}`,
      {},
      "DELETE"
    );
  },
  generarExcelEquivalencias: (idEfectorFacturacion) => {
    return fetchConToken(
      `EquivalenciasNomencladores/exportExcel/${idEfectorFacturacion}`
    );
  },

  // -- CONVENIOS NOMENCLADOS --
  traerCapitulos: () => {
    return fetchConToken(`Valorizaciones/GalenosGastos/TraerCapitulos`);
  },
  traerGalenosGastosCargados: (idEfectorFacturacion, tipoGalenosGastosPorFecha,codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta) => {
    return fetchConToken(
      `Valorizaciones/GalenosGastos/${idEfectorFacturacion}?tipoGalenosGastosPorFecha=${tipoGalenosGastosPorFecha}&codDesdeFiltro=${codDesdeFiltro}&codHastaFiltro=${codHastaFiltro}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
    );
  },
  enviarPrevisualizacion: (idEfectorFacturacion, data) => {
    return fetchConToken(
      `Valorizaciones/GalenosGastos/Previsualizacion/${idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  enviarPracticasConfirmadas: (data, idEfectorFacturacion) => {
    return fetchConToken(
      `Valorizaciones/GalenosGastos/${idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  eliminarPracticaActivaNomenclados: (idPracticaNomenclados, data) => {
    return fetchConToken(
      `Valorizaciones/GalenosGastos/Eliminar/${idPracticaNomenclados}`,
      data,
      "POST"
    );
  },
  eliminarPracticaActivaNomencladosMasivas: (data) => {
    ;
    return fetchConToken(
      `Valorizaciones/GalenosGastos/EliminarMasivo`,
      data,
      "POST"
    );
  },
  reactivarPracticaNomenclados: (idPracticaNomenclados) => {
    return fetchConToken(
      `Valorizaciones/GalenosGastos/Reactivar/${idPracticaNomenclados}`,
      {},
      "POST"
    );
  },
  editarNomenclados: (idPracticaNomenclados, data) => {
    return fetchConToken(
      `Valorizaciones/GalenosGastos/${idPracticaNomenclados}`,
      data,
      "PUT"
    );
  },

  // -- VALOR FIJO --
  traerPracticasValorFijo: (data) => {
    return fetchConToken(
      `Valorizaciones/ValorFijoCarga/${data.idEfectorFacturacion}?codPracticaDesde=${data.codPracticaDesde}&codPracticaHasta=${data.codPracticaHasta}&honGas=${data.honGas}&categoria=${data.categoria}&fechaInicioVigencia=${data.fechaInicioVigencia}`
    );
  },
  enviarPracticasActivasValorFijo: (data) => {
    return fetchConToken(
      `Valorizaciones/ValorFijo/${data.idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  traerPracticasActivasValorFijo: (idEfectorFacturacion, tipoPracticasPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta) => {
    return fetchConToken(
      `Valorizaciones/ValorFijo/${idEfectorFacturacion}?tipoPracticasPorFecha=${tipoPracticasPorFecha}&codDesdeFiltro=${codDesdeFiltro}&codHastaFiltro=${codHastaFiltro}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
    );
  },

  // -- NNX --
  traerPracticasNNX: (data) => {
    return fetchConToken(
      `Valorizaciones/NnxCarga/${data.idEfectorFacturacion}?codPracticaDesde=${data.codPracticaDesde}&codPracticaHasta=${data.codPracticaHasta}&valorNnx=${data.valorNnx}&fechaInicioVigencia=${data.fechaInicioVigencia}`
    );
  },
  enviarPracticasActivasNNX: (data) => {
    return fetchConToken(
      `Valorizaciones/Nnx/${data.idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  traerPracticasActivasNNX: (idEfectorFacturacion, tipoPracticasPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta) => {
    return fetchConToken(
      `Valorizaciones/Nnx/${idEfectorFacturacion}?tipoPracticasPorFecha=${tipoPracticasPorFecha}&codDesdeFiltro=${codDesdeFiltro}&codHastaFiltro=${codHastaFiltro}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
    );
  },

  // -- NBU --
  traerPracticasNBU: (data) => {
    return fetchConToken(
      `Valorizaciones/NbuCarga/${data.idEfectorFacturacion}?codPracticaDesde=${data.codPracticaDesde}&codPracticaHasta=${data.codPracticaHasta}&valorNbu=${data.valorNbu}&fechaInicioVigencia=${data.fechaInicioVigencia}`
    );
  },
  enviarPracticasActivasNBU: (data) => {
    return fetchConToken(
      `Valorizaciones/Nbu/${data.idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  traerPracticasActivasNBU: (idEfectorFacturacion, tipoPracticasPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta) => {
    return fetchConToken(
      `Valorizaciones/Nbu/${idEfectorFacturacion}?tipoPracticasPorFecha=${tipoPracticasPorFecha}&codDesdeFiltro=${codDesdeFiltro}&codHastaFiltro=${codHastaFiltro}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
    );
  },


  // -- VALORIZACIONES EN GENERAL --
  editarPractica: (idValorizacion, data) => {
    return fetchConToken(
      `Valorizaciones/${idValorizacion}`,
      data,
      "PUT"
    );
  },
  eliminarPracticaActivasMasivas: (data) => {
    return fetchConToken(
      `Valorizaciones/EliminarMasivo`,
      data,
      "POST"
    );
  },
  eliminarPracticaActivas: (idValorizacion, data) => {
    return fetchConToken(
      `Valorizaciones/Eliminar/${idValorizacion}`,
      data,
      "POST"
    );
  },
  reactivarPractica: (idValorizacion) => {
    return fetchConToken(
      `Valorizaciones/Reactivar/${idValorizacion}`,
      {},
      "POST"
    );
  },

  // -- MODULOS --
  traerModulosActivos: (idEfectorFacturacion, tipoPracticasPorFecha) => {
    return fetchConToken(
      `Valorizaciones/Modulos/${idEfectorFacturacion}?tipoPracticasPorFecha=${tipoPracticasPorFecha}`
    );
  },
  
  traerModulosCarga: (data) => {
    return fetchConToken(
      `Valorizaciones/ModulosCarga/${data.idEfectorFacturacion}?idModulo=${data.idModulo}&fechaInicioVigencia=${data.fechaInicioVigencia}&idHonGas=${data.idHonGas}`
    );
  },
  enviarModulo: (idEfectorFacturacion, data) => {
    return fetchConToken(
      `Valorizaciones/Modulos/${idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  eliminarModulo: (idValorizacion) => {
    return fetchConToken(
      `Valorizaciones/Modulos/${idValorizacion}`,
      {},
      "DELETE"
    );
  },
  reactivarModulo: (idValorizacion) => {
    return fetchConToken(
      `Valorizaciones/Modulos/Reactivar/${idValorizacion}`,
      {},
      "POST"
    );
  },
  editarModulo: (idValorizacion, data) => {
    return fetchConToken(
      `Valorizaciones/Modulos/${idValorizacion}`,
      data,
      "PUT"
    );
  },

  // -- PRESUPUESTOS --
  traerPresupuestos: (idEfectorFacturacion, tipoPracticasPorFecha) => {
    return fetchConToken(
      `Valorizaciones/Presupuestos/${idEfectorFacturacion}/${tipoPracticasPorFecha}`
    );
  },
  traerPresupuestosPortal: (idEfectorFacturacion, tipoPracticasPorFecha) => {
    return fetchConToken(
      `Valorizaciones/PresupuestosPortal/${idEfectorFacturacion}/${tipoPracticasPorFecha}`
    );
  },
  /*traerPresupuestosSinAutorizacionesActivos: (idEfectorFacturacion, tipoPracticasPorFecha) => {
    return fetchConToken(
      `Valorizaciones/PresupuestosSinAutorizaciones/${idEfectorFacturacion}?tipoPracticasPorFecha=${tipoPracticasPorFecha}`
    );
  },*/
  
  cargarPresupuesto: (idEfectorFacturacion, data) => {
    return fetchConToken(
      `Valorizaciones/Presupuestos/${idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  cargarPresupuestoSinAutorizaciones: (idEfectorFacturacion, data) => {
    return fetchConToken(
      `Valorizaciones/PresupuestosSinAutorizaciones/${idEfectorFacturacion}`,
      data,
      "POST"
    );
  },
  modificarPresupuesto: (idPresupuesto, data) => {
    return fetchConToken(
      `Valorizaciones/Presupuestos/${idPresupuesto}`,
      data,
      "PUT"
    );
  },

  // -- TRACKING PRESUPUESTOS --
  getTrackingPresupuesto: (idPresupuesto) => {
    return fetchConToken(
      `TrackingPresupuesto/traerPorPresupuestoContratos/${idPresupuesto}`
    );
  },

  //AUMENTO DE CONVENIOS
  setearAumentoConvenios: (idEfectorFacturacion, data) => {
    return fetchConToken(
      `Valorizaciones/CargarPorcentaje/${idEfectorFacturacion}`,
      data,
      "POST"
    );
  },

  //REPORTES CONVENIOS
  generarExcelValorizaciones: (idEfectorFacturacion, idTipoNomenclador, tipoPracticasPorFecha) => {
    return fetchConToken(
      `Valorizaciones/${idEfectorFacturacion}/${idTipoNomenclador}/GenerarExcel?tipoPracticasPorFecha=${tipoPracticasPorFecha}`
    );
  },
  generarPDFValorizaciones: (idEfectorFacturacion, idTipoNomenclador, tipoPracticasPorFecha) => {
    return fetchConToken(
      `Valorizaciones/${idEfectorFacturacion}/${idTipoNomenclador}/GenerarPDF?tipoPracticasPorFecha=${tipoPracticasPorFecha}`
    );
  },
}

export { ContratacionesConveniosService as default };
